import { useState, useEffect, useRef } from "react";
import get from "lodash/get";

/**
 * Example:
 * let [ loading, articles = []] = useSelfpointEffect(props)
 *
 * @param {} param0
 */

function useSelfpointEffect(props) {
  const {
    id,
    extra = {},
    effects = {},
    runEffect = () => {
      console.error("runEffect must be implemented");
    },
    context = {},
    watchArray = [],
  } = props;

  const [loading, setLoading] = useState(false);
  const { effects: _effects = null } = extra;

  const hasData = effects[id];

  const didMount = useRef(false);

  const dependencyArray = [...watchArray, _effects];

  useEffect(() => {
    // check for client params
    const firstSource = get(_effects, "source", null);

    if (firstSource === "Params/client") {
      const param = get(_effects, "param", null);
      const result = get(props, param, null); //filterString(param,props,{})
      runEffect({
        source: { source: firstSource, param: result },
        effectId: id,
        context,
      });
      return;
    }

    if (_effects) {
      runEffect({ source: _effects, effectId: id, context });
    }
    setLoading(true);
  }, dependencyArray);

  useEffect(() => {
    if (didMount.current) {
      setLoading(false);
    } else {
      didMount.current = true;
    }
  }, [hasData]);

  return [loading, typeof hasData === "undefined" ? null : hasData];
}

export default useSelfpointEffect;
